import { render, staticRenderFns } from "./RegistroTerminalDialog.vue?vue&type=template&id=0589740f"
import script from "./RegistroTerminalDialog.vue?vue&type=script&lang=js"
export * from "./RegistroTerminalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports